import { ReactNode } from 'react';
import { IconPound } from '@iwoca/icons';
import { Input } from '@iwoca/orion';
import { Controller, useFormContext } from 'react-hook-form';

type TProps = {
  name: string;
  label: ReactNode;
  error?: string;
  disabled?: boolean;
  // Drop the value from form state when the field unmounts, so we don't submit
  // stale conditional fields.
  shouldUnregister?: boolean;
};

export const CurrencyField = ({
  name,
  label,
  error,
  disabled,
  shouldUnregister,
}: TProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      shouldUnregister={shouldUnregister}
      render={({ field: { onChange, value, ref } }) => {
        const numericValue = value?.replace(/[^0-9]/g, '') ?? '';
        const formattedValue = numericValue
          ? parseInt(numericValue).toLocaleString()
          : '';

        return (
          <Input
            ref={ref}
            name={name}
            label={label}
            iconLeft={<IconPound />}
            type="text"
            inputMode="numeric"
            value={formattedValue}
            onChange={(e) => onChange(e.target.value.replace(/[^0-9]/g, ''))}
            error={error}
            disabled={disabled}
          />
        );
      }}
    />
  );
};
